import {API_URL} from 'api/constants'
export const LIBRARIES_EXPORT = `${API_URL}/v1/ingredients/export`
export const LIBRARY_DOWNLOAD_TEMPLATE = `LIBRARY_DOWNLOAD_TEMPLATE`
export const LIST_LIBRARY_URL = `${API_URL}/v1/ingredients`
export const INGREDIENT_WITH_UNCATEGORY = `${API_URL}/v1/ingredient_categories/with_uncategorized`
export const LIBRARY_SUMMARY_URL = `${API_URL}/v1/ingredients`
export const LIBRARY_BY_ID = (id) => (`${LIST_LIBRARY_URL}/${id}`)
export const CREATE_LIBRARY = `${API_URL}/v1/ingredients`
export const CREATE_ALL_OUTLET_LIBRARY = `${API_URL}/v1/ingredients/create_all_outlet`
export const UPDATE_LIBRARY_BY_ID = (id) => (`${LIBRARY_BY_ID(id)}/update_image`)
export const DELETE_LIBRARY_BY_ID_V1 = (id) => (`${LIBRARY_BY_ID(id)}`)
export const LIBRARY_GET_UNITS = `${API_URL}/v1/units`
export const INGREDIENT_CREATE_CATEGORY = `${API_URL}/v1/ingredient_categories`
export const V1_IMPORT_LIBRARY_TEMPORARY = `${API_URL}/v1/ingredients/import_temp`
export const V1_IMPORT_LIBRARY = `${API_URL}/v1/ingredients/import`
export const V1_IMPORT_LIBRARY_TEMPLATE = `${API_URL}/v1/ingredients/export?&inventory=all`



// WEBPACK FOOTER //
// ./app/api/ingredients/library/constants.js